<mat-card class="cardWithShadow">
  <mat-card-header class="header-container">
    <div class="header-content">
      <h2>Carga Masiva de Programación</h2>
      <p class="description">
        Utilice esta herramienta para cargar múltiples solicitudes de visita mediante un archivo Excel.
      </p>
    </div>
    <div class="header-spacer"></div>

    <div class="server-clock-container" *ngIf="serverTime">
      <mat-icon>schedule</mat-icon>
      <div class="time-display">
        <span>Hora Servidor</span>
        <strong>{{ serverTime | date:'HH:mm:ss' }}</strong>
      </div>
    </div>


    <div class="actions-container">
      <input type="file" (change)="onFileSelected($event)" accept=".xlsx, .xls" #fileInput id="fileInput" hidden />
      <button mat-flat-button color="primary" (click)="fileInput.click()" [disabled]="loading">
        <mat-icon>upload_file</mat-icon>
        Seleccionar Archivo
      </button>
      <button mat-stroked-button color="primary" (click)="downloadSampleExcel()" [disabled]="loading">
        <mat-icon>cloud_download</mat-icon>
        Descargar Plantilla
      </button>

      <button 
        mat-flat-button 
        color="accent"  class="execute-button" (click)="ejecutarProceso()" 
        [disabled]="processing || loading">
        
        <div class="button-content"> 
          <mat-icon *ngIf="!processing">play_arrow</mat-icon>
          <mat-spinner *ngIf="processing" diameter="20"></mat-spinner>
          <span class="button-text">{{ processing ? 'Procesando...' : 'Ejecutar Proceso Diario' }}</span>
        </div>
      </button>

      <button 
        *ngIf="dataSource.data.length > 0"
        mat-stroked-button 
        color="warn" 
        (click)="resetView()"
        [disabled]="loading">
        <mat-icon>delete_sweep</mat-icon>
        Limpiar Tabla
      </button>
    </div>

    <div class="actions-row secondary-actions">
      <div class="switch-group">
        <mat-icon 
          class="help-icon" 
          matTooltip="Actívelo para ver y procesar las visitas agendadas para hoy que estén pendientes o con error. Si está desactivado, el sistema solo procesará las de mañana."
          matTooltipPosition="above">
          help_outline
        </mat-icon>
        <mat-slide-toggle 
          [(ngModel)]="procesarHoy" 
          (change)="onSwitchChange()"
          color="primary"
          [disabled]="loading">
          Procesar visitas de <strong>hoy</strong>
        </mat-slide-toggle>
      </div>
    </div>
    
  </mat-card-header>

  <mat-card-content class="p-24">
    <div *ngIf="fileName" class="file-name-chip">
      <mat-icon>description</mat-icon>
      <span>{{ fileName }}</span>
    </div>

    <div *ngIf="dataSource.data.length > 0" class="preview-container">
      <div class="table-responsive mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column | titlecase }} </th>
            <td mat-cell *matCellDef="let element"> {{ element[column] }} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
              No se encontraron datos que coincidan con el filtro.
            </td>
          </tr>
        </table>
      </div>

      <div class="controls-container">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Búsqueda general</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar datos...">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons></mat-paginator>
      </div>
    </div>

    <div *ngIf="dataSource.data.length > 0" class="send-actions-container">
        <button 
          mat-flat-button 
          color="primary" 
          (click)="enviarDatos()"
          [disabled]="loading || dataSource.data.length === 0">
          <mat-icon *ngIf="!loading">send</mat-icon>
          <mat-spinner *ngIf="loading" diameter="20" color="accent"></mat-spinner>
          <span class="button-text">{{ loading ? 'Enviando...' : 'Enviar Datos a Programación' }}</span>
        </button>
    </div>

    <div *ngIf="dataSourceDiaria.data.length > 0" class="mt-16">
      <h3>Programación para {{ procesarHoy ? 'Hoy' : 'Mañana' }}</h3>

      <div class="table-responsive mat-elevation-z8">      
        <table mat-table [dataSource]="dataSourceDiaria" #tablaResultados>

          <ng-container matColumnDef="nombre_cliente">
            <th mat-header-cell *matHeaderCellDef> Cliente </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="editingRow?.id !== element.id">{{ element.nombre_cliente }}</span>
              <mat-form-field *ngIf="editingRow?.id === element.id" appearance="outline" class="dense-field">
                <input matInput [(ngModel)]="editingRow.nombre_cliente">
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="nombre_local">
            <th mat-header-cell *matHeaderCellDef> Local </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="editingRow?.id !== element.id">{{ element.nombre_local }}</span>
              <mat-form-field *ngIf="editingRow?.id === element.id" appearance="outline" class="dense-field">
                <input matInput [(ngModel)]="editingRow.nombre_local">
              </mat-form-field>
            </td>
          </ng-container>
          
          <ng-container matColumnDef="rut_tecnico1">
            <th mat-header-cell *matHeaderCellDef> RUT Técnico </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="editingRow?.id !== element.id">{{ element.rut_tecnico1 }}</span>
              <mat-form-field *ngIf="editingRow?.id === element.id" appearance="outline" class="dense-field">
                <input matInput [(ngModel)]="editingRow.rut_tecnico1">
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="estado_procesamiento">
            <th mat-header-cell *matHeaderCellDef> Estado </th>
            <td mat-cell *matCellDef="let element">
              <span class="status-chip" [ngClass]="{
                'status-success': element.estado_procesamiento === 'procesado',
                'status-error': element.estado_procesamiento === 'error',
                'status-pending': element.estado_procesamiento === 'pendiente'
              }">
                {{ element.estado_procesamiento | titlecase }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="mensaje_error">
            <th mat-header-cell *matHeaderCellDef> Mensaje </th>
            <td mat-cell *matCellDef="let element" class="error-message"> {{ element.mensaje_error }} </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="editingRow?.id !== element.id">
                <button mat-icon-button color="primary" (click)="startEdit(element)">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
              <div *ngIf="editingRow?.id === element.id">
                <button mat-icon-button color="primary" (click)="saveEdit()">
                  <mat-icon>save</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="cancelEdit()">
                  <mat-icon>cancel</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef> ID </th>
              <td mat-cell *matCellDef="let element"> {{ element.id }} </td>
          </ng-container>
          <ng-container matColumnDef="mes_facturacion">
              <th mat-header-cell *matHeaderCellDef> Mes Facturación </th>
              <td mat-cell *matCellDef="let element"> {{ element.mes_facturacion }} </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumnsDiaria"></tr>          
          <tr mat-row [ngClass]="{'error-row': row.estado_procesamiento === 'error'}" *matRowDef="let row; columns: displayedColumnsDiaria;"></tr>
        </table>
      </div>
    </div>
    

  </mat-card-content>
</mat-card>